import { FC, ReactComponentElement, ReactElement } from "react";
import React, { ReactNode } from "react";

interface SwitchCaseProps<T> {
  value: T;
  children: ReactNode;
}

export function Switch<T>({ value, children }: SwitchCaseProps<T>) {
  return (
    <>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          const { value: childValue, children } = child.props as CaseProps<T>;
          if (childValue === value) {
            return children;
          }
          if (child.type === Else) {
            return children;
          }
        }
        return null;
      })}
    </>
  );
}

interface CaseProps<T> {
  value: T;
  children: ReactNode;
}

export const Else: FC<{ children: ReactElement }> = (props: {
  children: ReactElement;
}) => {
  return <>{props.children!!}</>;
};

export function Case<T>({ value, children }: CaseProps<T>) {
  return <>{children}</>;
}

export const If: FC<CaseProps<boolean>> = ({ value, children }) => {
  return <>{value ? children : null}</>;
};
